module.exports = __webpack_public_path__ + "static/bob_slinky_logo_white-a597a867ad441e0dff44d90dadd3a59b.svg";